export const setStationId = (state, id) => {
  state.stationId = id;
};
